export default __webpack_public_path__ + "static/liquidity-icon-6f568b2ef25cc0c711aa7df0d30279af.svg";